import React from "react";
import { usePollingQuery } from "../../hooks";
import { ExerciseWargamesQuery } from "../../graphql";
import { RecentWargamesListView } from "../ListView";
export var RecentWargamesForExercise = function (_a) {
    var _b, _c;
    var serviceId = _a.serviceId, wargameExerciseId = _a.wargameExerciseId;
    var _d = usePollingQuery(ExerciseWargamesQuery, {
        variables: { id: wargameExerciseId }
    }), loading = _d.loading, data = _d.data;
    var wargames = (_c = (_b = data === null || data === void 0 ? void 0 : data.warGamesByExerciseID) === null || _b === void 0 ? void 0 : _b.rows) === null || _c === void 0 ? void 0 : _c.map(function (parsedWargame) { return ({
        id: parsedWargame.id,
        wargameTemplateId: parsedWargame.wargame_templates_id,
        wargameTemplateName: parsedWargame.wargame_template_name,
        status: parsedWargame.status,
        updatedAt: parsedWargame.updated_at
    }); });
    return (React.createElement(RecentWargamesListView, { serviceWargamesData: wargames, serviceId: serviceId, isLoading: loading, isFilterAvailable: false }));
};
